import { render, staticRenderFns } from "./PredefinedAnswerCreate.vue?vue&type=template&id=4d171ba1&"
import script from "./PredefinedAnswerCreate.vue?vue&type=script&lang=js&"
export * from "./PredefinedAnswerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports